import { useEffect, useMemo, useState } from 'react';
import { Divider, Flex, List,  Space,Collapse } from 'antd';
import { useHouduankaifaListQuery } from '../../store/BnsKeJiApi';
import { backendAction } from './backendAction';
import Copy from '../../cpn/Copy';
import BackendEdit from './BackendEdit';
import BackendDel from './BackendDel';
import BackendAdd from './BackendAdd';
function BackendList(props) {
    const [list, setList] = useState([]);
    const [selectedAction, setSelectedAction] = useState('');
    
    // 当props.et_id变化时，重置筛选状态
    useEffect(() => {
        setSelectedAction('');
    }, [props.et_id]);
    
    const {data, isSuccess} = useHouduankaifaListQuery({
        'etul_et_id': props.et_id,
        'etul_state': '',
        'etul_etul_id': '',
        'etul_bbb_id': '',
        'etul_name': ''
    },{refetchOnMountOrArgChange:1, skip: !props.et_id});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {etul_id:key,etul_name,etul_ctime,etul_cname,etul_content,etul_state,etul_luyou,etul_image,etul_goods,etul_price, etul_action, etul_require,etul_uid} = item;
                    return item = {key,etul_name,etul_ctime,etul_cname,etul_content,etul_state,etul_luyou,etul_image,etul_goods,etul_price, etul_action, etul_require,etul_uid}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.etul_ctime;
                    let bTimeString = b.etul_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])  

    // 计算可用的筛选标签（根据当前列表中存在的 etul_action 值）
    const availableActions = useMemo(() => {
        const values = Array.from(new Set((list || []).map(i => String(i.etul_action || '')).filter(Boolean)));
        return backendAction.filter(a => values.includes(String(a.value)));
    }, [list]);

    // 根据选择的标签过滤展示列表
    const filteredList = useMemo(() => {
        if (!selectedAction) return list;
        return list.filter(item => String(item.etul_action || '') === String(selectedAction));

    }, [list, selectedAction]);

    const isActiveStyle = (active) => active ? { color:'#1677ff', fontWeight:'bold', fontSize:'16px' } : undefined;

    
    return (
        <div style={{padding:"20px",background:"#ccc",marginTop:"10px"}}>
            <Flex justify='space-between' align='center' style={{background:"#fff",padding:"15px",borderRadius:"4px"}}>
                <Space style={{marginTop:"10px"}} size={20}>
                    {list && <a onClick={() => setSelectedAction('')} style={isActiveStyle(selectedAction === '')}>全部</a>}
                    {availableActions.map(a => (
                        <a 
                            key={a.value} 
                            onClick={() => setSelectedAction(String(a.value))}
                            style={isActiveStyle(String(selectedAction) === String(a.value))}
                        >
                            {a.label}
                        </a>
                    ))}
                </Space>    
                <BackendAdd 
                    bg_id={props?.bg_id}
                    bg_name={props?.bg_name}
                    bgn_id={props?.bgn_id}
                    bgn_name={props?.bgn_name}
                    bbb_id={props?.bbb_id}
                    bbb_name={props?.bbb_name}
                    et_id={props?.et_id}
                    et_name={props?.et_name}                    
                />            
            </Flex>
            <List>
                {filteredList?filteredList.map((item,index) => {
                    const action = backendAction.find((a) => String(a.value) === String(item.etul_action));
                    const title = action?.label || '';
                    const names = (item.etul_name || '').split(',').map(s => s.trim()).filter(Boolean);
                    const requireLabels = (item.etul_require || '').split(',').map(s => s.trim()).filter(Boolean).map(v => v === '1' ? '必填' : v === '2' ? '可选' : v);
                    return  <List.Item 
                                key={item.key}
                                style={{background:"#fff",padding:"15px",borderRadius:"4px",marginTop:"2px"}}
                            >
                                <List.Item.Meta 
                                    title={
                                        <Flex justify='space-between'>
                                            <Space style={{fontSize:"18px", color:"#FF6600"}} size={30}>
                                                <span>{item.etul_ctime}</span>
                                                <span>id：{item.key}</span>
                                                <span>任务类型：{title}</span>
                                            </Space>
                                            <Space>
                                                <BackendEdit etul_uid={item.etul_uid} etul_id={item.key}/>
                                                <BackendDel etul_uid={item.etul_uid}  etul_id={item.key}/>
                                            </Space>
                                        </Flex>
                                    } 
                                    description={
                                        index === 0 ? (
                                            <div>
                                                <div 
                                                    dangerouslySetInnerHTML={{__html:item.etul_content}} 
                                                    style={{
                                                        fontSize: "14px",
                                                        color: "#000000",
                                                        marginTop: "20px",
                                                        wordBreak: "break-all",
                                                        whiteSpace: "pre-wrap",
                                                        overflowWrap: "break-word"
                                                    }}
                                                ></div>
                                                {(names.length > 0) && (
                                                    <>
                                                        <Divider>参数列表</Divider>
                                                        <Space direction='vertical' style={{marginTop:"8px", fontSize:"14px",}}>
                                                            {names.map((n, idx) => {
                                                                const label = requireLabels[idx] || '';
                                                                return (
                                                                    <Space key={idx}>
                                                                        <span>{idx+1}、</span> 
                                                                        <Copy title={n} /> 
                                                                        {label && <span style={label === '必填' ? {color:"#FF6600"} : {color:"green"}}>{label}</span>}
                                                                    </Space>
                                                                )
                                                            })}
                                                        </Space>
                                                    </>
                                                )}
                                            </div>
                                        ) : (
                                            <Collapse ghost style={{background: "transparent"}} defaultActiveKey={[]}>
                                                <Collapse.Panel 
                                                    key="1" 
                                                    header={
                                                        <a style={{fontSize:"16px"}}>[点击展开] 已完成任务详情</a>
                                                    }
                                                    showArrow
                                                >
                                                    <div dangerouslySetInnerHTML={{__html:item.etul_content}} style={{fontSize:"14px",color:"#000000",marginTop:"20px"}}></div>
                                                    {(names.length > 0) && (
                                                        <>
                                                            <Divider>参数列表</Divider>
                                                            <Space direction='vertical' style={{marginTop:"8px", fontSize:"14px",}}>
                                                                {names.map((n, idx) => {
                                                                    const label = requireLabels[idx] || '';
                                                                    return (
                                                                        <Space key={idx}>
                                                                            <span>{idx+1}、</span> 
                                                                            <Copy title={n} /> 
                                                                            {label && <span>{label}</span>}
                                                                        </Space>
                                                                    )
                                                                })}
                                                            </Space>
                                                        </>
                                                    )}
                                                </Collapse.Panel>
                                            </Collapse>
                                        )}
                                    
                                />
                            </List.Item>
                    }):<List.Item
                            style={{background:"#fff",padding:"15px",borderRadius:"4px",marginTop:"2px"}}
                        >
                            <List.Item.Meta
                               title='暂无任务！'
                            >

                            </List.Item.Meta>
                        </List.Item>}
            </List>
        </div>
    );
}

export default BackendList;